import { onMounted, onBeforeUnmount, ref, reactive, watch, nextTick } from "vue";
import BannerSwiper from "@/components/BannerSwiper/index.vue";
import Job from "@/pages/contactUs/components/job.vue";
export default {
  components: {
    BannerSwiper: BannerSwiper,
    Job: Job
  },
  name: "Index",
  setup: function setup() {
    var num = ref(4); // 根据视口宽度动态修改 swiper 展示数量

    var viewportWidth = ref(window.innerWidth);

    var updateViewportWidth = function updateViewportWidth() {
      viewportWidth.value = window.innerWidth;
    }; // 在组件挂载后开始监听窗口大小变化


    onMounted(function () {
      nextTick(function () {
        var id = 'job';
        id = decodeURIComponent(id);
        var el = document.getElementById(id); // console.log('滚动到：', id, el)

        if (el) {
          // 平滑滚动
          setTimeout(function () {
            el.scrollIntoView({
              behavior: 'smooth'
            });
          }, 200);
        }
      });
    }); // 在组件卸载前移除事件监听器

    onBeforeUnmount(function () {
      window.removeEventListener("resize", updateViewportWidth);
    });
    watch(num, function (newValue) {
      //  console.log(newValue,'变化了吗');;
      num.value = newValue;
    });
    var bannerList = reactive([{
      id: 0,
      // imageUrl: "https://cdn.tenacia.com/base/tenacia-img/new_banner_ctu_02.jpg",
      imageUrl: require('./image/1-2.jpg')
    }]);
    return {
      bannerList: bannerList,
      num: num
    };
  }
};